<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="hxJdOrderCode"
      border
      auto-resize
      resizable
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="485"
      :checkbox-config="{ highlight: true, trigger: 'row' }"
    >
      <template v-slot:vehicle="{ row }">
        <div v-if="row.hxJdVehicleCode">
          <span class="mr-1">
            {{ $l('table_label_carNumberPlate') || '车牌号' }}:
          </span>
          <span>{{ row.carNumberPlate || '' }}</span>
          <br />
          <span class="mr-1">
            {{ $l('table_label_vehicleModel') || '车型' }}:
          </span>
          <span>{{ row.vehicleModel || '' }}</span>
        </div>
        <div v-else class="d-flex justify-content-center">
          <el-tag size="mini">
            {{ $l('table_label_orderNoBindvehicle') || '尚未绑定车辆' }}
          </el-tag>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './order-table-columns'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    hxJdVehicleCode: { type: String, default: '' },
    hxShipmentJdCode: { type: String, default: '' },
  },
  data() {
    return {
      tableData: [],
      loading: false,
      tableColumns: tableColumns(this),
    }
  },
  async mounted() {
    await this.getData()
    this.setCheckdRows()
  },
  methods: {
    async getData() {
      if (!this.hxShipmentJdCode) return
      this.loading = true
      const res = await this.$api
        .ecomHxShipmentJdOrderListApi({
          hxShipmentJdCode: this.hxShipmentJdCode,
        })
        .catch(() => null)
      this.loading = false
      this.tableData = res?.body?.data || []
    },
    setCheckdRows() {
      if (!this.hxJdVehicleCode) return
      const rows = this.tableData.filter(
        (item) => item.hxJdVehicleCode === this.hxJdVehicleCode
      )
      if (!rows?.length) return
      this.$refs.table.setCheckboxRow(rows, true)
    },
    getCheckboxRecords() {
      return this.$refs.table.getCheckboxRecords(true)
    },
  },
}
</script>
